import React from 'react';
import OptionCheckbox from './OptionCheckbox';

const MotorizationOption = props => {
  const { option, disabled, analyticsKey, onChange } = props;
  const { id, selected, conflict, name } = option;

  const onSelect = () => {
    if (!selected) {
      onChange(option);
    }
  };

  return (
    <div className="option">
      <div className="option__row">
        <div>
          <OptionCheckbox
            id={id}
            checked={selected}
            conflict={conflict}
            disabled={disabled}
            analyticsKey={analyticsKey}
            analyticsKey2={name}
            onChange={onSelect}
          />
        </div>
        <div className="option__column">
          <div
            className="stat-checkbox"
            data-dtm={analyticsKey}
            data-dtm2={name}>
            <div
              onClick={onSelect}
              className={`option__title option__title--small option__selectable ${
                selected ? 'option__selectable--disabled' : ''
              }`}>
              {name}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MotorizationOption;
